export const IMPACT_COURSE_TOUR_TARGETS = {
  learningButtonWeb: "learning-button-suraasa-plus-new-year-joyride-web",
  learningButtonMobile: "learning-button-suraasa-plus-new-year-joyride-mobile",
  impactCourse: "impact-course-suraasa-plus-new-year-joyride",
  courseTour: {
    milestoneList: "course-milestone-list-suraasa-plus-new-year-joyride",
    resourceTab: "resource-tab-suraasa-plus-new-year-joyride",
  },
}
